import Immutable from 'immutable'
import moment from 'moment'

import createExtra from './Extra'

export const TransitRecord = Immutable.Record({
  allowanceDownloadOffpeak: null,
  allowanceDownloadPeak: null,
  allowanceUploadOffpeak: null,
  allowanceUploadPeak: null,
  allowanceWarningThreshold: null,
  bandwidthPacks: null,
  downSpeedBits: null,
  excessUsage: null,
  excessUsageCharge: 0,
  externalNetwork: false,
  hostname: null,
  ipRanges: Immutable.Set(),
  ipv6Prefix: null,
  lastUsage: null,
  lastUsageUpdated: null,
  nextUsageInvoice: null,
  upSpeedBits: null,
  usageInterval: null,
  usageIps: Immutable.Set(),
  wanIp: null,
}, 'ServiceTransit')

/* eslint-disable camelcase */
export default function createServiceTransit({
  allowance_download_offpeak,
  allowance_download_peak,
  allowance_upload_offpeak,
  allowance_upload_peak,
  allowance_warning_threshold,
  bandwidth_packs = [],
  down_speed_bits,
  excess_usage,
  excess_usage_charge,
  external_network,
  ip_ranges = [],
  ipv6_prefix,
  last_usage,
  last_usage_updated,
  next_usage_invoice,
  next_usage_period,
  up_speed_bits,
  usage_interval,
  usage_ips,
  wan_ip,
  ...data
}) {
  return new TransitRecord({
    allowanceDownloadOffpeak: allowance_download_offpeak ? parseInt(allowance_download_offpeak, 10) : null,
    allowanceDownloadPeak: allowance_download_peak ? parseInt(allowance_download_peak, 10) : null,
    allowanceUploadOffpeak: allowance_upload_offpeak ? parseInt(allowance_upload_offpeak, 10) : null,
    allowanceUploadPeak: allowance_upload_peak ? parseInt(allowance_upload_peak, 10) : null,
    allowanceWarningThreshold: parseFloat(allowance_warning_threshold),
    bandwidthPacks: Immutable.Set(bandwidth_packs.map(pack => createExtra(pack))),
    downSpeedBits: down_speed_bits ? parseInt(down_speed_bits, 10) : null,
    excessUsage: excess_usage,
    excessUsageCharge: parseFloat(excess_usage_charge),
    externalNetwork: external_network,
    ipRanges: Immutable.Set(ip_ranges),
    ipv6Prefix: ipv6_prefix,
    lastUsage: last_usage ? parseInt(last_usage, 10) : null,
    lastUsageUpdated: last_usage_updated ? moment(last_usage_updated) : null,
    nextUsageInvoice: next_usage_invoice ? moment(next_usage_invoice) : null,
    nextUsagePeriod: next_usage_period ? moment.duration(next_usage_period) : null,
    upSpeedBits: up_speed_bits ? parseInt(up_speed_bits, 10) : null,
    usageInterval: usage_interval ? moment.duration(usage_interval) : null,
    usageIps: Immutable.Set(usage_ips),
    wanIp: wan_ip,
    ...data,
  })
}
/* eslint-enable camelcase */



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Service/Transit.js